import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import NavBar from "../Components/NavBar/NavBar";
import Footer from "../Components/Footer/Footer";
import { Helmet } from "react-helmet";

const PMOServices = () => {
  const pmoImages = [
    "https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg",
    "https://images.pexels.com/photos/1181244/pexels-photo-1181244.jpeg",
    "https://images.pexels.com/photos/3861969/pexels-photo-3861969.jpeg",
  ];

  const offerings = [
    "Project Portfolio Governance",
    "Budgeting, Forecasting & Resource Allocation",
    "Agile, Hybrid & Waterfall Methodology Support",
    "KPI Tracking and Reporting Automation",
    "Risk & Compliance Oversight",
    "Tools Implementation and PMO Setup",
  ];

  return (
    <>
      <Helmet>
        <title>PMO Services | Dhanam Information Systems</title>
        <meta
          name="description"
          content="Expert PMO Services by Dhanam Information Systems. Governance, resource management, project delivery, and more."
        />
      </Helmet>

      <NavBar />

      <section className="pmo-hero text-white d-flex align-items-center">
        <Container>
          <Row className="align-items-center">
            <Col md={6}>
              <h1 className="display-4 fw-bold">PMO Services</h1>
              <p className="lead">
                Empower your enterprise with strategic project governance, resource optimization, and delivery excellence through our PMO services.
              </p>
            </Col>
            <Col md={6}>
              <img
                src="https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg"
                alt="PMO Services"
                className="img-fluid rounded shadow"
              />
            </Col>
          </Row>
        </Container>
      </section>

      <section className="py-5 bg-light">
        <Container>
          <h2 className="text-center mb-4">Our PMO Offerings</h2>
          <ul className="list-unstyled fs-5 ps-3">
            {offerings.map((item, index) => (
              <li key={index} className="mb-2">✔ {item}</li>
            ))}
          </ul>
        </Container>
      </section>

      <section className="py-5">
        <Container>
          <h2 className="text-center mb-4">PMO in Action</h2>
          <Row>
            {pmoImages.map((img, i) => (
              <Col md={4} key={i} className="mb-4">
                <Card className="shadow-sm">
                  <Card.Img variant="top" src={`${img}?auto=compress&cs=tinysrgb&h=350`} alt={`PMO ${i + 1}`} />
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <Footer />

      <style jsx>{`
        .pmo-hero {
          background: linear-gradient(to right, #0b163f, #14254c);
          padding: 80px 0;
          min-height: 60vh;
        }

        ul li {
          list-style: none;
          position: relative;
          padding-left: 1.5em;
        }

        ul li::before {
          position: absolute;
          left: 0;
          color: green;
          font-weight: bold;
        }

        ::selection {
          background-color: #0b163f;
          color: white;
        }

        body {
          user-select: none;
        }

        /* Disable right click */
        body {
          -webkit-touch-callout: none;
          -webkit-user-select: none;
          -khtml-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
        }

        body::after {
          content: "";
          display: none;
        }

        body:context-menu {
          display: none;
        }
      `}</style>
    </>
  );
};

export default PMOServices;
